import '../styles/Hero.css';

export default function Hero() {
  return (
    <section id='hero' className="hero">
      <div className="hero-box">
        <h2>CONFÍA, ACTÚA, AVANZA</h2>
        <p>Intervenimos operaciones de compra, venta y gestión de activos inmobiliarios en todo el territorio nacional, con un foco especial en Madrid. Nuestra trayectoria nace en el sector del alquiler en 2020, en los meses previos a la pandemia. Desde entonces, el camino ha sido exigente, pero también enriquecedor, y lleno de aprendizaje.</p>
        <button onClick={() => {
       const form = document.getElementById('contact');
       form.scrollIntoView({ behaviour: 'smooth'});
      }}>¿Nos conocemos?</button>
      </div>
    </section>
  );
}